import axios from "axios";
import { useState } from "react";
import { useMutation } from "react-query";
import { baseUrl } from "../config/base-url";

export const useFileUploadMutation = () => {
  const [progress, setProgress] = useState(0);
  const [result, setResult] = useState();

  const mutation = useMutation(
    "upload_file",
    (data) => {
      let formData = new FormData();
      formData.append("file", data.file);
      formData.append("row_id", data.rowId);
      formData.append("file_type", data.fileType || "photo");
      formData.append("row_type", data.rowType || "category");

      return axios.post(`${baseUrl()}/upload_photo/${data.id}`, formData, {
        headers: {
          "Content-Type": `multipart/form-data`,
          Authorization:
            `Bearer ` + (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).user?.tk : null),
        },
        onUploadProgress: (ev) => setProgress(Math.round((ev.loaded * 100) / ev.total)),
      });
    },
    {
      onSuccess: (data) => setResult({ type: "success", data: data }),
      onError: (data) => setResult({ type: "error", data: data }),
      onSettled: () => setProgress(0),
    }
  );

  return { mutation, progress, result };
};
